import React from "react";
import {  useNavigate } from "react-router-dom";
import Heading from "../common/Heading";
import "../css/homepage-sections.css";

export default function Blogs(props) {
    const navigate = useNavigate();

    function redirectToBlogsPage(){
        navigate('/blogs')
    }
    const {blogsData,isBlogsPage}=props
  return (
    <>
      <div className="professional-blogs-section">
        <div className="container-fluid pt-5 pb-5">
          {/* Professional Section Header */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <div className="professional-section-badge">
                <i className="fas fa-leaf mr-2"></i>
                Wisdom & Wellness
              </div>
              <h2 className="professional-section-title">
                Discover the Sacred Art of 
                <span className="gradient-text"> Incense & Spirituality</span>
              </h2>
              <p className="professional-section-subtitle">
                Explore ancient wisdom, modern practices, and the transformative power of natural fragrances in your spiritual journey.
              </p>
            </div>
          </div>

          {/* Blog Cards */}
          <div className="row px-xl-5 justify-content-center">
            {blogsData&&blogsData.map((item, index) => (
              <div className={"col-md-6 col-lg-" + (isBlogsPage ? "6" : "3") + " mb-4"} key={index}>
                <div className="professional-blog-card">
                  <div className="blog-card-header">
                    <div className="blog-icon">
                      <i className={`fas fa-${index % 4 === 0 ? 'om' : index % 4 === 1 ? 'leaf' : index % 4 === 2 ? 'fire' : 'lotus'}`}></i>
                    </div>
                    <div className="blog-category">
                      {index % 4 === 0 ? 'Spirituality' : index % 4 === 1 ? 'Natural Living' : index % 4 === 2 ? 'Rituals' : 'Wellness'}
                    </div>
                  </div>
                  
                  <div className="blog-card-content">
                    <h4 className="blog-title">{item.que}</h4>
                    <p className="blog-excerpt" dangerouslySetInnerHTML={{ __html: item.ans + '...' }}></p>
                    
                    {!isBlogsPage && (
                      <div className="blog-card-footer">
                        <button 
                          className="professional-read-more-btn"
                          onClick={redirectToBlogsPage}
                        >
                          <span>Read More</span>
                          <i className="fas fa-arrow-right ml-2"></i>
                        </button>
                        <div className="blog-meta">
                          <span className="read-time">
                            <i className="fas fa-clock mr-1"></i>
                            {Math.floor(Math.random() * 3) + 2} min read
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="blog-card-overlay"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          {!isBlogsPage && (
            <div className="row justify-content-center mt-5">
              <div className="col-lg-6 text-center">
                <div className="blogs-cta-section">
                  <h4 className="cta-title">Deepen Your Spiritual Journey</h4>
                  <p className="cta-subtitle">Explore our complete collection of articles on mindfulness, natural living, and sacred practices.</p>
                  <button 
                    className="professional-cta-btn"
                    onClick={redirectToBlogsPage}
                  >
                    <i className="fas fa-book-open mr-2"></i>
                    Explore All Articles
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
